import { render, staticRenderFns } from "./CDSDateInput.vue?vue&type=template&id=58252271"
import script from "./CDSDateInput.vue?vue&type=script&lang=js"
export * from "./CDSDateInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports